import React from 'react';
import { useAccordion} from '../../components/hooks/hooks-mongoDB/useAccordionState';

import {NavHeadLinks} from '../../components/modules/pannelli/HeadLink';
import { MenuMobile } from '../../components/modules/pannelli/MenuMobile'; 
import AccordionProvince from '../../components/modules/accordion/Accordion';
import AbruzzoMap from '../../components/svgs/AbruzzoMap';

import abXS from '../../components/images/province/intestato/AbruzzoViniWd500.png';
import abS from '../../components/images/province/intestato/AbruzzoViniWd800.png';
import abM from '../../components/images/province/intestato/AbruzzoViniWd1200.png';
import abL from '../../components/images/province/intestato/AbruzzoViniWd1600.png';
import abXL from '../../components/images/province/intestato/AbruzzoViniWd2000.png';
import abXXL from '../../components/images/province/intestato/AbruzzoViniWd3500.png';

import Abruzzo from './Abruzzo';
import Chieti from './Chieti';
import Aquila from './Aquila';
import Pescara from './Pescara';
import Teramo from './Teramo';

import './province.scss';

function Province() {
    const {accordion, setAccordionState, themes} = useAccordion();
    
    function setSectionMap(value) {
        let id = parseInt(value);
        for (var j in accordion) {
            if(accordion[j].id_accord === id && accordion[j].isActive === false) {
                accordion[j].isActive = true;
            } else
                accordion[j].isActive = false;
        }
        setAccordionState([...accordion]);
    }

    return (
        <section>
            <NavHeadLinks title="Province dell'Abruzzo" picXS={abXS} picS={abS} picM={abM} picL={abL} picXL={abXL} picXXL={abXXL} />
            <MenuMobile temi={themes}/>
            <div className="layout-grid__province">
                {accordion[0] && <AccordionProvince data={accordion} setAccordionState={setAccordionState}/>}
                {accordion[0] && <AbruzzoMap handlerId={setSectionMap} data={accordion}/>}
            </div>
            {accordion[0] && <div>
                {accordion[0].isActive && <Abruzzo data={accordion[0].stateLinks}/>}
                {accordion[1].isActive && <Aquila data={accordion[1].stateLinks}/>}
                {accordion[2].isActive && <Chieti data={accordion[2].stateLinks} />}
                {accordion[3].isActive && <Pescara data={accordion[3].stateLinks}/>}
                {accordion[4].isActive && <Teramo data={accordion[4].stateLinks}/>}
            </div>} 
        </section>
    )
}
export default Province;
